<template>
  <div class="app-container">
    <CrudTable entity="Domain" :columns="columns" :generate-summary="generateSummary" />
  </div>
</template>

<script>
import CrudTable from '@/components/crud/CrudTable';
export default {
  components: {
    CrudTable
  },
  data() {
    return {
      columns: [
        { field: 'orderNumberPrefix', label: 'domain.orderNumberPrefix' },
        'name',
        'description',
        {
          field: 'domainType',
          label: 'common.type',
          formatter: this.formatDomainType,
          sortable: false,
          filter: {
            type: 'select',
            options: this.$store.getters['option/loadedOptions']('domainType'),
            valueField: 'code',
            labelField: 'description'
          }
        },
        { field: 'companyName', label: 'common.company' },
        'phone',
        'companyEmail'
      ]
    };
  },
  methods: {
    generateSummary({ name, description }) {
      let summary = `${name}`;
      if (description) {
        summary += ` (${description})`;
      }
      return summary;
    },
    formatDomainType(row, column, cellValue) {
      const option =
        cellValue !== null &&
        this.$store.getters['option/loadedOptions']('domainType').find(item => item.code === cellValue);
      return option && option.description;
    }
  }
};
</script>
